import { initialTaskNotificationState, actions } from "./action";

export const taskNotificationReducer = (state = initialTaskNotificationState, action) => {
    switch (action.type) {
        case actions.TASKNOTIFICATION_GET_ALL_SUCCESS:
            return {
                ...state,
                taskNotificationList:  action.payload ? action.payload : {}
            };
        case actions.TASKNOTIFICATION_UPDATE_SUCCESS:
            return {
                ...state,
                taskNotificationDetails: action.payload?.id ? {...action.payload, action: 'update'} : {}
            };
        case actions.TASKNOTIFICATION_CREATE_SUCCESS:
            return {
                ...state,
                taskNotificationDetails: action.payload?.id ? {...action.payload, action: 'create'} : {}
            };
        case actions.TASKNOTIFICATION_DELETE_SUCCESS:
            return {
                ...state,
                taskNotificationDetails: action.payload?.id ? {...action.payload, action: 'delete'} : {}
            };
        case actions.TASKNOTIFICATION_RESET_SUCCESS:
            return {
                ...state,
                taskNotificationDetails: {}
            };
        default:
            return state;
    }
};
